
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { ModalLayout } from '@appbase/templates'

@Component({
    components: {
        ModalLayout,
    },
})
export default class IFrameModal extends Vue {
    @Prop({ type: String }) src!: string
    @Prop({ type: String }) title!: string
    @Prop({ type: Boolean, default: false }) noHeader!: boolean;
    @Prop({ type: Boolean, default: false }) noFooter!: boolean;    
    @Prop({ type: String, default: 'width: 1024px; height: 600px; padding:0' }) mStyle!: string

    mounted() {              
        this.injectClose();                                
    }

    injectClose() {
        var _this = this;
        var iframeElem = this.$refs.contentFrame as HTMLIFrameElement;  
                
        if(iframeElem && iframeElem.contentWindow) {
            (iframeElem.contentWindow as any).close = function() { _this.onCloseModal(); }  
        }        
    }

    onCloseModal() {       
        this.closeCurrentModal()
    }
}
